import {
  APP_TRACE_ANNOUNCEMENT_DISMISSED,
  APP_TRACE_ANNOUNCEMENT_SHOWN,
  APP_TRACE_PROP_MESSAGE_VERSION,
} from 'constants/telemetry';
import { writeTrace } from './service';

const buildAnnouncementTraceProperties = (
  messageVersion: string,
  extra?: Record<string, string>,
) => {
  return {
    [APP_TRACE_PROP_MESSAGE_VERSION]: messageVersion,
    ...(extra || {}),
  };
};

export const AppTrace = {
  announcementShown(messageVersion: string): void {
    writeTrace(
      APP_TRACE_ANNOUNCEMENT_SHOWN,
      buildAnnouncementTraceProperties(messageVersion),
    );
  },

  announcementDismissed(
    messageVersion: string,
    extra?: Record<string, string>,
  ): void {
    writeTrace(
      APP_TRACE_ANNOUNCEMENT_DISMISSED,
      buildAnnouncementTraceProperties(messageVersion, extra),
    );
  },
};
